module.exports = __webpack_public_path__ + "static/media/goshiyong.77bff367.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/goshiyong.png
// module id = 272
// module chunks = 2